"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var abstractmessage_1 = require("./abstractmessage");

var Reply = /*#__PURE__*/function (_abstractmessage_1$Ab) {
  _inherits(Reply, _abstractmessage_1$Ab);

  function Reply(id) {
    var _this;

    _classCallCheck(this, Reply);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Reply).call(this, id));
    _this.method = 'reply';
    _this.payload_type = 'application/json';
    _this.status = {
      code: 200,
      status: 'OK'
    };
    return _this;
  }

  return Reply;
}(abstractmessage_1.AbstractMessage);

exports.Reply = Reply;